import classNames from 'classnames';
import { FC } from 'react';

import { WaitingRoomMemberChangedStatus } from '@gem/call/Model/callModel.types';
import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { CallDescription } from './CallDescription/CallDescription';
import styles from './StartCall.styles.m.css';

interface IStartCallProps {
  showDescription?: boolean;
  isLoading: boolean;
  onStart(): void;
  onCancel(): Promise<void>;
  waitingRoomMemberStatus: WaitingRoomMemberChangedStatus | null;
  className?: string;
}

export const StartCall: FC<IStartCallProps> = ({
  onStart,
  isLoading,
  waitingRoomMemberStatus,
  onCancel,
  showDescription = true,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.container, className)}>
      {showDescription && <CallDescription className={styles.description} />}
      {waitingRoomMemberStatus === WaitingRoomMemberChangedStatus.Requested ? (
        <span className={styles.askingToJoin}>{t('calls_waiting_room_asking_join_message')}</span>
      ) : (
        <Button
          onClick={onStart}
          className={styles.joinButton}
          size="20"
          theme="primary"
          isLoading={isLoading}
        >
          {t('calls_join')}
        </Button>
      )}
      <Button
        onClick={onCancel}
        className={styles.cancelButton}
        size="20"
        theme="secondary"
      >
        {t('cancel')}
      </Button>
    </div>
  );
};
